import React from "react";
import "./styles.scss";


const RollerSwitcher = ({ isActive, onClickAction, bgColor }) => {
  return (
    <div
      style={{
        textAlign: "center",
        "--switcher-active": bgColor,
      }}
      onClick={onClickAction}
    >
      <div
        className={
          isActive ? `SwitchBtn SwitchOn` : `SwitchBtn`
        }
      />
    </div>
  );
};

export default RollerSwitcher;
